import {
  GET_ALL_QUESTIONS,
  GET_ASSESSMENT_OBJECTIVES,
  GET_QUESTION,
  GET_MARK_SCHEMES,
  GET_MOST_USED_ASSESSMENT_OBJECTIVES,
} from "./Queries";
import {
  AUTO_GENERATE_QUESTION_MUTATION,
  CREATE_QUESTION_MUTATION,
  DELETE_SOURCE_IMAGE_MUTATION,
  SUGGEST_MARK_SCHEME_MUTATION,
  UPDATE_QUESTION_MUTATION,
  SUBMIT_REVIEW_MUTATION,
  EXTRACT_QUESTIONS_AND_MARKSCHEMES_MUTATION,
} from "./Mutations";
import { ADD_QUESTION_TAGS_MUTATION } from "./Mutations";

export class QuestionClient {
  constructor(client) {
    this.client = client;
  }

  async addQuestionTags({ question, tags }) {
    const res = await this.client.mutate({
      mutation: ADD_QUESTION_TAGS_MUTATION,
      variables: { question, tags },
      fetchPolicy: "no-cache",
    });
    return res.data.addQuestionTags;
  }

  async getQuestion({ question }) {
    const res = await this.client.query({
      query: GET_QUESTION,
      variables: { question },
      fetchPolicy: "network-only",
    });
    return res.data;
  }

  async getAllQuestions({
    searchString,
    subjects,
    educationLevels,
    fromSameSchool,
    userOnly,
    published,
    questionType,
    quizOnly,
    assignmentOrQuizCreate,
    first = 20,
    after = null,
  }) {
    const res = await this.client.query({
      query: GET_ALL_QUESTIONS,
      variables: {
        searchString: searchString,
        educationLevels: educationLevels,
        subjects: subjects,
        fromSameSchool: fromSameSchool,
        userOnly: userOnly,
        published: published,
        questionType: questionType,
        quizOnly: quizOnly,
        assignmentOrQuizCreate: assignmentOrQuizCreate,
        first: first,
        after: after,
      },
    });
    return res.data.allQuestions;
  }
  async getAssessmentObjectives({ educationLevel, subject }) {
    const res = await this.client.query({
      query: GET_ASSESSMENT_OBJECTIVES,
      variables: { educationLevel, subject },
      fetchPolicy: "network-only",
    });
    return res.data;
  }

  async getMostUsedAssessmentObjectiveCombinations({
    subject,
    educationLevel,
  }) {
    const res = await this.client.query({
      query: GET_MOST_USED_ASSESSMENT_OBJECTIVES,
      variables: { subject, educationLevel },
    });
    return res.data;
  }
  async autoGenerateQuestion({
    subject,
    yearGroup,
    questionType,
    includeSourceText,
    specificFocus,
  }) {
    const res = await this.client.mutate({
      mutation: AUTO_GENERATE_QUESTION_MUTATION,
      variables: {
        subject,
        yearGroup,
        questionType,
        includeSourceText,
        specificFocus,
      },
    });
    return res.data.generatedQuestion;
  }

  async createQuestion({
    subject,
    yearGroup,
    tags,
    questionText,
    sourceText,
    questionType,
    images,
  }) {
    const res = await this.client.mutate({
      mutation: CREATE_QUESTION_MUTATION,
      variables: {
        subject,
        yearGroup,
        tags,
        questionText,
        questionType,
        sourceText,
        images,
      },
    });
    return res.data.createQuestion;
  }
  async updateQuestion({
    question,
    questionText,
    questionType,
    sourceText,
    tags,
    markScheme,
    publish,
    images,
  }) {
    const res = await this.client.mutate({
      mutation: UPDATE_QUESTION_MUTATION,
      variables: {
        question,
        questionText,
        questionType,
        sourceText,
        tags,
        markScheme,
        publish,
        images,
      },
      fetchPolicy: "network-only",
    });
    return res.data.updateQuestion;
  }

  async deleteSourceImage({ sourceImages }) {
    const res = await this.client.mutate({
      mutation: DELETE_SOURCE_IMAGE_MUTATION,
      variables: {
        sourceImages,
      },
    });
    return res.data.deleteSourceImage;
  }

  async suggestMarkScheme({ question, aoConfig }) {
    const res = await this.client.mutate({
      mutation: SUGGEST_MARK_SCHEME_MUTATION,
      variables: {
        question,
        aoConfig,
      },
    });
    return res.data.suggestMarkScheme;
  }
  async submitReview({ question, rating, comment = "" }) {
    const res = await this.client.mutate({
      mutation: SUBMIT_REVIEW_MUTATION,
      variables: {
        question,
        rating,
        comment,
      },
    });
    return res.data.submitReview;
  }

  async extractQuestionsAndMarkSchemes({
    files,
    yearGroup,
    subject,
    includesMarkScheme,
    singleQuestion,
    quizGroup = null,
    assignment = null,
  }) {
    const res = await this.client.mutate({
      mutation: EXTRACT_QUESTIONS_AND_MARKSCHEMES_MUTATION,
      variables: {
        files,
        subject,
        yearGroup,
        includesMarkScheme,
        singleQuestion,
        quizGroup,
        assignment,
      },
    });
    return res.data.extractQuestions;
  }

  async searchMarkSchemes({ name, subject, educationLevel }) {
    const res = await this.client.query({
      query: GET_MARK_SCHEMES,
      variables: { name, subject, educationLevel },
    });
    return res.data.matchedMarkSchemes;
  }
}
